import {
  AfterViewInit,
  Component,
  DoCheck,
  OnInit,
} from '@angular/core';
import {WpdForm} from "../_models/wpd-form";
import {ApiService} from "../_services/api.service";
import {FormulaConfig, SalaryRise, SIRate} from "../_models/formula-config";
import {SwiperOptions} from "swiper/types";
import {ChatStatus} from "../_models/chat-status";
import {Router} from "@angular/router";
import * as $ from 'jquery';
import * as moment from 'moment';
import 'src/assets/js/vendor/jquery.scrollbar.min';
import Swiper from "swiper";
import {MatSelect} from "@angular/material/select";
import {formatNumber} from "@angular/common";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

const breakpoint = window.matchMedia( '(min-width: 980.98px)' );
const MENU_H = 70;
// const MSG_DELAY = 100;
// const NEXT_QUES_DELAY = 100;
const MSG_DELAY = 1000;
const NEXT_QUES_DELAY = 1000;
var numItems;
var scroll_top_num = 2400;
const CHAT_SCROLL_TIME = 500;

@Component({
  selector: 'app-roboadv-chat',
  templateUrl: './roboadv-chat.component.html',
  styleUrls: ['./roboadv-chat.component.css']
})
export class RoboadvChatComponent implements OnInit,DoCheck,AfterViewInit {

  chat: WpdForm = {
    code: '',
    datetime: '',
    name: '',
    phone: '',
    mail: '',
    gender: '',
    ageNow: 36,
    industry: '',
    salary: 50000,
    ageRetire: 65,
    saveSum: 0,
    saveMth: 0,
    laborPension: null,
    laborInsurance: null,
    retireTotal: 0,
    retireNet: 0,
    ROI1TotalMth: 0,
    ROI2TotalMth: 0,
    ROI3TotalMth: 0,
    ROI1NetMth: 0,
    ROI2NetMth: 0,
    ROI3NetMth: 0,
    pipn_version: 'WPD202101',
    personnalDate: '',
    privacyYn: '',
    dataSource: ''
  };

  // 紀錄按鈕的問題回答進度
  chatStatus: ChatStatus = {
    ageNow: false,
    salary: false,
    ageRetire: false,
    retireTotal: false, // 退休金總額-我知道了
    saveSum: false,
    saveMth: false,
    detailA: false, // 請告訴我詳情
    detailB: false, // 還有呢
    letsGo: false,
    submit: false, // 確定送出
  };

  industries: SalaryRise[] = [];
  formulaConfigs: FormulaConfig = {
    // 放一組預設值
    "ageMort": [
      {
        "retireAge": 60,
        "lifetime": 24
      },
      {
        "retireAge": 61,
        "lifetime": 24
      },
      {
        "retireAge": 62,
        "lifetime": 23
      },
      {
        "retireAge": 63,
        "lifetime": 22
      },
      {
        "retireAge": 64,
        "lifetime": 21
      },
      {
        "retireAge": 65,
        "lifetime": 20
      },
      {
        "retireAge": 66,
        "lifetime": 20
      },
      {
        "retireAge": 67,
        "lifetime": 19
      },
      {
        "retireAge": 68,
        "lifetime": 18
      },
      {
        "retireAge": 69,
        "lifetime": 17
      },
      {
        "retireAge": 70,
        "lifetime": 17
      },
      {
        "retireAge": 71,
        "lifetime": 16
      },
      {
        "retireAge": 72,
        "lifetime": 15
      },
      {
        "retireAge": 73,
        "lifetime": 14
      },
      {
        "retireAge": 74,
        "lifetime": 14
      },
      {
        "retireAge": 75,
        "lifetime": 13
      },
      {
        "retireAge": 76,
        "lifetime": 12
      },
      {
        "retireAge": 77,
        "lifetime": 12
      },
      {
        "retireAge": 78,
        "lifetime": 11
      },
      {
        "retireAge": 79,
        "lifetime": 10
      },
      {
        "retireAge": 80,
        "lifetime": 10
      },
      {
        "retireAge": 81,
        "lifetime": 9
      },
      {
        "retireAge": 82,
        "lifetime": 9
      },
      {
        "retireAge": 83,
        "lifetime": 8
      },
      {
        "retireAge": 84,
        "lifetime": 8
      },
      {
        "retireAge": 85,
        "lifetime": 7
      }
    ],
    "salaryRise": [
      {
        "code": "a",
        "name": "農、林、漁、牧業",
        "rate": 0.34333
      },
      {
        "code": "b",
        "name": "礦業及土石採取業",
        "rate": 0.34333
      },
      {
        "code": "c",
        "name": "製造業",
        "rate": 2.32333
      },
      {
        "code": "d",
        "name": "電力及燃氣供應業",
        "rate": 0.01
      },
      {
        "code": "e",
        "name": "用水供應及污染整治業",
        "rate": 0.92333
      },
      {
        "code": "f",
        "name": "營建工程業",
        "rate": 0.78
      },
      {
        "code": "g",
        "name": "批發及零售業",
        "rate": 2.71333
      },
      {
        "code": "h",
        "name": "運輸及倉儲業",
        "rate": 2.33667
      },
      {
        "code": "i",
        "name": "住宿及餐飲業",
        "rate": 2.68333
      },
      {
        "code": "j",
        "name": "出版、影音製作、傳播及資通訊服務業",
        "rate": 2.65333
      },
      {
        "code": "k",
        "name": "金融及保險業",
        "rate": 1.53667
      },
      {
        "code": "l",
        "name": "不動產業",
        "rate": 4.64
      },
      {
        "code": "m",
        "name": "專業、科學及技術服務業",
        "rate": 2.67667
      },
      {
        "code": "n",
        "name": "支援服務業",
        "rate": 2.02
      },
      {
        "code": "o",
        "name": "公共行政及國防；強制性社會安全",
        "rate": 1.53667
      },
      {
        "code": "p",
        "name": "教育業",
        "rate": 5.87
      },
      {
        "code": "q",
        "name": "醫療保健及社會工作服務業",
        "rate": 0.00001
      },
      {
        "code": "r",
        "name": "藝術、娛樂及休閒服務業",
        "rate": 2.48
      },
      {
        "code": "s",
        "name": "其他服務業",
        "rate": 2.56667
      }
    ],
    "accumRate": 5.4402,
    "annuityRate": 0.987,
    "finalSalary": 45800,
    "inflation": 1.4,
    "interest": 0.77,
    "penConCap": 9000,
    "penRate": 6,
    "penYears": 35,
    "retireExpRate": 75,
    "socSecRate": 1.55,
    "SIRate1": {
      "name": "0%",
      "rate": 0.00001
    },
    "SIRate2": {
      "name": "2%",
      "rate": 2
    },
    "SIRate3": {
      "name": "6%",
      "rate": 6
    }
  };

  swiperSummaryOption: SwiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: false,
    autoplay: false,
    pagination: {
      clickable: true,
      el: '.ra-thx-swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.ra-thx-swiper-button-next',
      prevEl: '.ra-thx-swiper-button-prev',
    },
    on: {
      transitionStart: (swiper:Swiper) => {
        // 開始滑動時，關閉 "計算方式"
        if ($('[data-id="idSummaryNoteTg"]').hasClass('open')) {
          //if summary note is opened
          $('[data-id="idSummaryNoteTg"]').removeClass('open');
          $('[data-id="idSummaryNoteTg"]').siblings('.jsToggleBody').slideToggle();
        }
      }
    },
  };

  submitting: boolean = false; // 表單送出中
  minAgeRetire: number = 65;

  // FIXME 只用在填寫資料, 下方總覽處無法套用 why??
  patternEmail = /^[a-z0-9][a-z0-9._-]+[a-z0-9]@[a-z0-9][a-z0-9-]*[a-z0-9]\.([a-z0-9][a-z0-9-]*[a-z0-9]\.?)+/i;

  constructor(private apiService: ApiService,
              private sanitizer: DomSanitizer,
              private router: Router) { }

  ngOnInit(): void {
    let personnalDate = localStorage.getItem('personnalDate');
    if(personnalDate==null) {
      // 尚未同意個資，返回首頁
      this.router.navigate(['home']);
      // return;
    }
    this.apiService.getFormulaConfigs().subscribe(config => {
      console.log('getFormulaConfigs', config);
      this.industries = config.salaryRise;
      this.formulaConfigs = config;
      // this.chat.industry = x.salaryRise[0].code; // 預選第一個才會顯示
    });
    let chat = localStorage.getItem('chat');
    if(chat!=null) {
      this.chat = JSON.parse(chat);
    }
    this.chat.personnalDate = personnalDate!;
    this.chat.code = localStorage.getItem('CODE')!;
    let chatStatus = localStorage.getItem('chatStatus');
    if(chatStatus!=null) {
      this.chatStatus = JSON.parse(chatStatus);
    }
  }

  ngDoCheck() {
    this.calcMinAgeRetire();
    this.calcPensionNeeded();
    this.calcPensionNet();
    // this.chat.laborPension=null;
    // this.chat.laborInsurance=null;
    localStorage.setItem('chat', JSON.stringify(this.chat));
    localStorage.setItem('chatStatus', JSON.stringify(this.chatStatus));
  }

  ngAfterViewInit() {
    //memo modal
    $('[data-close="idSlideMemolist"]').on('click', function () {
      $('[data-id="idSlideMemo"]').slideUp(200);
      $('[data-id="idSlideMemolist"]').addClass('ra-hide');
    });
    $('[data-open="idSlideMemolist"]').on('click', function () {
      if($(this).hasClass('active')){
        $(this).removeClass('active');
      }
      $('[data-id="idSlideMemolist"]').removeClass('ra-hide');
      $('[data-id="idSlideMemo"]').slideDown(200);
    });
    $(window).resize(function() {
      if (breakpoint.matches === true) {
        $('[data-id="idSlideMemo"]').slideUp(200);
        $('[data-id="idSlideMemolist"]').addClass('ra-hide');
      }
    });

    //toggle
    $('.jsToggle').on('click', function () {
      $(this).toggleClass('open');
      $(this).siblings('.jsToggleBody').slideToggle();
    });

    //summary, viewer/editor toggle
    $('[data-open="idSummaryOpenEditor"]').on('click', function () {
      let editor_id = $(this).attr("data-open-editor");
      // $('[data-viewer="'+ editor_id +'"]').slideUp();
      // $('[data-editor="'+ editor_id +'"]').slideDown();
      $('[data-open="idSummaryOpenEditor"]').hide();
      $('[data-viewer="'+ editor_id +'"]').slideToggle();
      $('[data-editor="'+ editor_id +'"]').slideToggle();
    });
    $('[data-open="idSummaryOpenViewer"]').on('click', function () {
      let viewer_id = $(this).attr("data-open-viewer");
      // $('[data-viewer="'+ viewer_id +'"]').slideDown();
      // $('[data-editor="'+ viewer_id +'"]').slideUp();
      $('[data-open="idSummaryOpenEditor"]').show();
      $('[data-viewer="'+ viewer_id +'"]').slideToggle();
      $('[data-editor="'+ viewer_id +'"]').slideToggle();
    });

    //footer anchor, to top/ to bottom
    $('[data-id="idAnchorTop"]').on('click', function () {
      let scroll_top =  $('.jsWelcomeChat').offset()!.top - MENU_H;
      $('.jsChatMainWrapper').animate({ scrollTop: scroll_top }, CHAT_SCROLL_TIME);
    });
    $('[data-id="idAnchorBottom"]').on('click', function () {
      let scroll_bottom =  $('.jsWelcomeChat').height() ;
      $('.jsChatMainWrapper').animate({ scrollTop: scroll_bottom }, CHAT_SCROLL_TIME);
    });

    this.chatAnimation();

    // scrollbar on mobile
    let scrollbar:any = $('.scrollbar-inner');
    scrollbar.scrollbar();

    //------ 完整版
    //progress bar toggle - PC
    $('[data-toggle = "idProgressBarPC"]').on('click', function () {
      if ($('[data-target ="idProgressBarPC"]').hasClass('close')) {
        $('[data-target ="idProgressBarPC"]').removeClass('close');
      } else {
        $('[data-target ="idProgressBarPC"]').addClass('close');
      }
    });
    //progress bar toggle - Mobile
    $('[data-toggle = "idProgressBarMo"]').on('click', function () {
      if ($('[data-target ="idProgressBarMo"]').hasClass('close')) {
        $('[data-target ="idProgressBarMo"]').removeClass('close').fadeOut(0).fadeIn(100);
      } else {
        $('[data-target ="idProgressBarMo"]').fadeOut(100, function () {
          $(this).addClass('close'); //or any other class
        });
      }
    });
  }
  
  private chatAnimation() {

    function triggerNextGroup(currentGroupName:string, doINeedToScroll:boolean){
      numItems = $(currentGroupName).length;
      // console.log(currentGroupName + " numItems: " + numItems);
      for (let i = 0; i < numItems; i++) {
        showMsgBoxByGroup(currentGroupName, i, doINeedToScroll);
      }
    }
    function showMsgBoxByGroup(currentGroupName:string, i:number, doINeedToScroll:boolean) {
      setTimeout(function() {
        $(currentGroupName).eq(i).fadeIn(500);
        if(doINeedToScroll)
          doScrollUp();
      }, i * MSG_DELAY);
    }
    function showMemoByGroup(currentMemoGroup:string) {
      $(currentMemoGroup).fadeIn();
    }
    function triggerMemoIconAlert(){
      $('[data-open="idSlideMemolist"]').addClass('active');
    }

    function doScrollUp(){
      let testNearestTop = $(".jsScrollToHere").last().offset()!.top - MENU_H - 10;  //scroll to last user msg
      let testWelcomeTop = $('.jsWelcomeChat').offset()!.top - MENU_H;  //top of curretn scroll position
      // console.log('robotmsg- i scroll= ' + (testNearestTop - testWelcomeTop));
      scroll_top_num += (testNearestTop - testWelcomeTop);
      $('.jsChatMainWrapper').animate({ scrollTop: (scroll_top_num) }, CHAT_SCROLL_TIME);
      // console.log('robotmsg- i now= ' + scroll_top_num);
    }

    ///////////////////////////////////////
    // 動畫腳本
    ///////////////////////////////////////

    $(".jsMsgBox").hide();

    //----------- 個資聲明 ques
    triggerNextGroup('[data-chat-group="idGender-Ques"]', true);

    //question btn click
    $('.jsChatTrigger').on('click', function () {

      //btn disabled 則不處理
      if($(this).hasClass('jsBtnDisabled') ){
        return false;
      }

      let ansGroupName = $(this).attr("data-trigger-ans");
      let memoGroupName = $(this).attr("data-trigger-ans");
      let nextQuesGroupName = $(this).attr("data-trigger-next");
      //if has been clicked, doesnt need to scroll up page
      let hasBeenClicked = $(this).attr("data-hasbeenclicked");
      let doINeedToScroll = (hasBeenClicked == "true") ? false : true;

      //accessAllowed = (age > 18) ? true : false;
      console.log('get Id: '+ansGroupName +'/' +memoGroupName +'/' +nextQuesGroupName);
      console.log('doINeedToScroll: '+doINeedToScroll);
      if(hasBeenClicked == "false"){
        $(this).attr("data-hasbeenclicked", "true");
        console.log('update data-hasbeenclicked: '+$(this).attr("data-hasbeenclicked"));
      }
      //-----------this ans
      if(ansGroupName != "NONE"){
        triggerNextGroup('[data-chat-group="'+ansGroupName+'"]', doINeedToScroll);
        showMemoByGroup('[data-memo-group="'+memoGroupName+'"]');
      }

      //-----------next ques
      setTimeout(function() {
        triggerNextGroup('[data-chat-group="'+nextQuesGroupName+'"]', doINeedToScroll);
        //退休金總額&淨額 簡單總結
        if( nextQuesGroupName == "idRetireTotalSimple-Ques" || nextQuesGroupName == 'idRetireMoney-Ques'){
          triggerMemoIconAlert();
        }
      }, NEXT_QUES_DELAY);

      //最後一題!
      if(memoGroupName == "idPersonalInfo-Ans"){
        $('.jsRobotContinue').fadeOut();
      }

      return true;
    }); //$('.jsChatTrigger')

  }

  get genderClass(): string {
    switch (this.chat.gender) {
      case "b":
        return 'ra-gender-boy';
      case "g":
        return 'ra-gender-girl';
      default:
        return 'ra-gender-unknown';
    }
  }

  get genderText(): string {
    switch (this.chat.gender) {
      case "b":
        return '男生';
      case "g":
        return '女生';
      default:
        return '未選擇';
    }
  }

  private calcMinAgeRetire(): void {
    let min = Math.max(this.chat.ageNow+1,60);
    this.chat.ageRetire = Math.max(this.chat.ageRetire, min);
    this.minAgeRetire = min;
  }

  getMoneyText(value: number): SafeHtml {
    let txt = '';
    if(value>=1e4) {
      txt = formatNumber(value/1e4, 'en', '1.0-3') +
          '<span style="font-size:0.8em; font-weight: normal">萬</span>';
    }
    else if(value>=1e3) {
      txt = formatNumber(value/1e3, 'en', '1.0-3') +
          '<span style="font-size:0.8em; font-weight: normal">千</span>';
    }
    else {
      txt = formatNumber(value, 'en', '1.0-0');
    }

    return this.sanitizer.bypassSecurityTrustHtml(txt);
  }

  formatLabel(value: number) {
    // if(value>=1e7) {
    //   // return Math.floor(value/1e6) + 'm';
    //   return formatNumber(value/1e6, 'en', '1.1'); // 不要 m 以免寬度不夠
    // }
    if(value>=1e6) {
      // return Math.round(value/1e6, 1) + 'm';
      return formatNumber(value/1e6, 'en', '1.1') + 'm';
    }
    if(value>=1000) {
      return Math.round(value/1000) + 'k';
    }
    return value;
  }

  get industry_text(): string {
    this.chat.industry_text = this.industries.find(x=>x.code==this.chat.industry)?.name || '尚未選擇';
    return this.chat.industry_text;
  }

  get excludeItemText(): string {
    let txt = [];
    if(this.chat.saveSum) {
      txt.push('您已準備的資金');
    }
    if(this.chat.laborPension) {
      txt.push('勞退');
    }
    if(this.chat.laborInsurance) {
      txt.push('勞保');
    }
    return txt.join('、');
  }

  triggerNext(target: HTMLDivElement) {
    // console.log('triggerNext', target);
    target.click();
  }

  // 退休金總額
  private calcPensionNeeded(): void {
    // console.log('pensionNeeded');
    let retiredExpMth = this.chat.salary * 0.75;
    let interest = this.formulaConfigs.interest / 100;
    let inflation = this.formulaConfigs.inflation / 100;
    let ageRetire = this.chat.ageRetire;
    let ageNow = this.chat.ageNow;
    let ageMort = ageRetire + this.formulaConfigs.ageMort.find(x=>x.retireAge==ageRetire)!.lifetime;
    let needed = retiredExpMth*12*Math.pow(inflation+1, ageRetire-ageNow);
    needed *= (1+interest)/(1+inflation);
    needed *= (1-Math.pow((1+interest)/(1+inflation), -(ageMort-ageRetire))) / (((1+interest)/(1+inflation))-1);
    this.chat.retireTotal = needed;
  }

  // 計算退休金淨額
  private calcPensionNet(): void {
    let interest = this.formulaConfigs.interest / 100;
    let ageRetire = this.chat.ageRetire;
    let ageNow = this.chat.ageNow;
    let ageMort = ageRetire + this.formulaConfigs.ageMort.find(x=>x.retireAge==ageRetire)!.lifetime;
    let savingsSum = this.chat.saveSum;
    let savingsMth = this.chat.saveMth;
    let penConCap = this.formulaConfigs.penConCap;
    let penRate = this.formulaConfigs.penRate / 100;
    let penYears = this.formulaConfigs.penYears;
    let accumRate = this.formulaConfigs.accumRate / 100;
    let annuityRate = this.formulaConfigs.annuityRate / 100;
    let finalSalary = this.formulaConfigs.finalSalary;
    let socSecRate = this.formulaConfigs.socSecRate / 100;
    let salary = this.chat.salary;
    let salaryRiseObj = this.formulaConfigs.salaryRise.find(x=>x.code==this.chat.industry);
    if(!salaryRiseObj) {
      return;
    }
    let salaryRise = salaryRiseObj.rate/100;

    // 至今退休積蓄纍積金額(纍積至退休年齡)
    let pension1 = savingsSum * Math.pow(1+interest, ageRetire-ageNow);

    // 進行中退休積蓄定期定額金額(纍積至退休年齡)
    let pension2 = (savingsMth*12) * (Math.pow(1+interest, ageRetire-ageNow)-1) / interest;

    // 勞工退休縂額
    let p1 = Math.log10(penConCap/(salary*penRate)) / Math.log10(1+salaryRise);
    let p2 = p1 - ageRetire + ageNow + penYears;
    let p3 = (1+salaryRise) / (1+accumRate);
    // console.log('pensionNet param', p1);
    let pension3 = (penRate*salary*12) * Math.pow(1+salaryRise, ageRetire-ageNow-penYears)
        * Math.pow(1+accumRate, penYears-1);
    if((p1 + ageNow) > ageRetire) {
      // console.log('pension3-1');
      pension3 *= (1-Math.pow(p3, penYears)) / (1-p3);
    }
    else if((p1 + ageNow)<=ageRetire && (ageRetire-ageNow-p1)<penYears) {
      // console.log('pension3-2');
      pension3 *= (1-Math.pow(p3, p2)) / (1-p3);
      let tmp = (penConCap*12)*Math.pow(1+accumRate, penYears-1) * (1/Math.pow(1+accumRate,p2));
      pension3 += tmp*(1-Math.pow(1/(1+accumRate), (penYears - p2))) / (1-(1/(1+accumRate)));
    }
    else if((ageRetire-ageNow-p1)>=penYears) {
      // console.log('pension3-3');
      pension3 = (penConCap*12) * (Math.pow(1+accumRate, penYears)-1) / accumRate;
    }
    else {
      console.warn('未知pension3範圍');
    }
    // console.log('勞工退休縂額(6%)', pension3);

    // 月勞工退休金金額
    let p41 = 1 / Math.pow(1+annuityRate, ageMort-ageRetire-1);
    let pension4 = pension3 / ((1-p41)/annuityRate+1) / 12;
    // console.log('月勞工退休金金額', pension4);

    // 退休金净額
    let p51 = 1 + (1 - 1/Math.pow(1+interest, ageMort-ageRetire-1))/interest;
    let pension5 = this.chat.retireTotal - pension1 - pension2;
    if(this.chat.laborPension) {
      pension5 -= pension4*12*p51; // 有不明誤差
    }
    if(this.chat.laborInsurance) {
      pension5 -= penYears*finalSalary*socSecRate*12*p51;
    }
    this.chat.retireNet = pension5;

    // console.log('pension1-4', pension1, pension2, pension3, pension4, pension5);

    // 計算SIRate1-3 (0、2、6%)回報率情境, 所需每月存款
    function calcSIRate(pension: number, siRate: SIRate) {
      let rate = siRate.rate / 100;
      return pension*(rate/(Math.pow(1+rate, ageRetire-ageNow)-1))*(1/12);
    }
    this.chat.ROI1NetMth = calcSIRate(pension5, this.formulaConfigs.SIRate1);
    this.chat.ROI2NetMth = calcSIRate(pension5, this.formulaConfigs.SIRate2);
    this.chat.ROI3NetMth = calcSIRate(pension5, this.formulaConfigs.SIRate3);
    this.chat.ROI1TotalMth = calcSIRate(this.chat.retireTotal, this.formulaConfigs.SIRate1);
    this.chat.ROI2TotalMth = calcSIRate(this.chat.retireTotal, this.formulaConfigs.SIRate2);
    this.chat.ROI3TotalMth = calcSIRate(this.chat.retireTotal, this.formulaConfigs.SIRate3);
  }

  convertToNumber(value: string): number {
    return parseInt(value);
  }
  convertToString(value: number): string {
    return value.toString();
  }

  delayShow(e:MatSelect): void {
    setTimeout(() => {
      e.open();
    }, 100);
  }

  submit(): void {
    this.submitting = true;
    this.chat.datetime = moment().format('YYYY/MM/DD HH:mm:ss'); // 填單時間
    this.chat.dataSource = localStorage.getItem('dataSource') || '';
    this.chat.privacyYn = localStorage.getItem('privacyYn') || '';
    this.apiService.fillWPDForm(this.chat).subscribe(ok => {
      // console.log('fillWPDForm', ok);
      this.submitting = false;
      if(ok) {
        // localStorage.clear();
        // 只刪除問卷資料，保留場次與個資同意時間等其他參數
        localStorage.removeItem('chat');
        localStorage.removeItem('chatStatus');
        // this.router.navigate(['thx', 'submit']);
      } else {
        alert('送出失敗');
      }
    })
  }
}
